import { useMemoizedFn, useUnmount } from 'ahooks';
import { Button, message } from 'antd';
import { useRef, useState } from 'react';
import { EventSourceQuery, useEventSource } from 'views/BootGuide/hooks/useEventSource';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { useTranslate } from '@tolgee/react';

interface GPTReGeneratorBtnProps {
  path?: string;
  query: EventSourceQuery;
  onFinish?: (value: string) => void;
}

export const GPTReGeneratorBtn = (props: GPTReGeneratorBtnProps) => {
  const { path, query, onFinish } = props;

  const { t } = useTranslate();

  const getSource = useEventSource(path);

  const [loading, setLoading] = useState(false);

  const sourceRef = useRef<EventSourcePolyfill | null>(null);

  const handleGPTGenerate = useMemoizedFn(() => {
    sourceRef.current = getSource(query);
    setLoading(true);
    let value = '';
    sourceRef.current.addEventListener('message', function (event) {
      try {
        const data: any = JSON.parse(event.data);
        if (data.ops === 'generating') {
          value += data.content;
        }
        if (data.ops === 'done') {
          sourceRef?.current?.close();
          setLoading(false);
          requestAnimationFrame(() => {
            onFinish?.(value);
            message.success('生成成功');
          });
        }
      } catch (e) {
        console.log(e);
      }
    });
    sourceRef.current.addEventListener('error', function () {
      sourceRef?.current?.close();
      setLoading(false);
      message.error('生成失败');
    });
  });

  useUnmount(() => {
    sourceRef?.current?.close();
  });

  return (
    <Button className="!p-0" type="link" loading={loading} onClick={handleGPTGenerate}>
      {t('gpt_renew_content')}
    </Button>
  );
};
